import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { PHONE_TEL, PHONE_DISPLAY } from "../../lib/media";

const Header = () => {
  const { t, lang, setLang } = useLang();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: t.nav.home, end: true },
    { to: "/services", label: t.nav.services },
    { to: "/portfolio", label: t.nav.portfolio },
    { to: "/process", label: t.nav.process },
    { to: "/reviews", label: t.nav.reviews },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-header">
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center group" data-testid="nav-logo" aria-label="GA Signature home">
          <img
            src="/logo.png"
            alt="GA Signature — Painting, Electricity and Remodeling"
            className="h-14 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
            style={{ mixBlendMode: "lighten" }}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <div
            className="flex items-center rounded-full border border-white/15 p-1 text-xs font-semibold"
            data-testid="lang-toggle"
          >
            <button
              onClick={() => setLang("en")}
              className={`px-3 py-1 rounded-full transition ${lang === "en" ? "bg-white text-black" : "text-white/70 hover:text-white"}`}
              data-testid="lang-en"
            >
              EN
            </button>
            <button
              onClick={() => setLang("es")}
              className={`px-3 py-1 rounded-full transition ${lang === "es" ? "bg-white text-black" : "text-white/70 hover:text-white"}`}
              data-testid="lang-es"
            >
              ES
            </button>
          </div>
          <a href={`tel:${PHONE_TEL}`} className="btn-ghost h-10 px-4 text-sm" data-testid="header-call-btn">
            <Phone className="w-4 h-4" />
            {PHONE_DISPLAY}
          </a>
          <Link to="/contact" className="btn-primary h-10 px-5 text-sm" data-testid="header-quote-btn">
            {t.nav.quote}
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0A0A0C]" data-testid="mobile-menu">
          <div className="container-x py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-lg font-display ${isActive ? "text-white" : "text-white/70"}`
                }
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <button
                onClick={() => setLang("en")}
                className={`px-3 py-1 rounded-full border ${lang === "en" ? "bg-white text-black border-white" : "border-white/15 text-white/70"}`}
                data-testid="mobile-lang-en"
              >
                EN
              </button>
              <button
                onClick={() => setLang("es")}
                className={`px-3 py-1 rounded-full border ${lang === "es" ? "bg-white text-black border-white" : "border-white/15 text-white/70"}`}
                data-testid="mobile-lang-es"
              >
                ES
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
